
import '../App.css';
import {useState, useEffect} from 'react';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image } from 'react-bootstrap';

export default function Hero() {
    return (
        <div>
      <div className='Hero1'>
      <Container style={{height:"80vh"}}>
        <Row style={{height:"75vh"}}>
          <Col className='hero-col' style={{textAlign:"start"}}>
            <p className='BrandTitle'>Blaudent</p>
            <h1 className='Title'>
                NAERATADES HOMSESSE
            </h1>
            <p className='hero-subtitle'>
                Täiskasvanute ja laste ortodontiline ravi
            </p>
            <div className='hero-b' style={{display:"flex", flexWrap:"wrap", alignItems: "center", gap:"0.75rem", textAlign:"end"}} >
                <Button className='hero-b1' size='lg' style={{height:"60px", width:"200px", borderRadius:"24px", flexShrink:"1", lineHeight:"200%"}} href='/broneeri'>Broneeri aeg</Button>
                <Button className='hero-b1' size='lg' style={{height:"60px", width:"200px", borderRadius:"24px", textAlign:"center", lineHeight:"200%", flexShrink:"1"}} href='tel:+37255661618'>+372 5566 1618</Button>
                {/*<Button className='hero-b2' size='mg' style={{height:"50px", width:"160px", borderRadius:"24px", flexShrink:"1"}}>Broneeri aeg</Button>*/}
                {/*<Button className='hero-b2' size='mg' style={{height:"50px", width:"160px", borderRadius:"24px", textAlign:"center", lineHeight:"220%", flexShrink:"1"}} href='tel:+37256920388'>+123 4567890</Button>*/}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    <Container style={{marginTop:"2.5rem", marginBottom:"3rem"}}>
      <h1 style={{marginBottom:"1.25rem"}}>
        Mis on ortodontia?
      </h1>
      <p style={{fontWeight:"500", fontSize:"20px"}}>
        Ortodontia on hambaravi eriala, mis tegeleb hammaste ja lõualuude asendi ning hambumuse korrigeerimisega. Ortodontilise ravi eesmärk on saavutada korrektne hambumus, sirged hambad ja tasakaalus näoprofiil, parandades nii suu tervist kui ka naeratuse esteetikat.
      </p>
    </Container>
    <Container>
      <hr></hr>
    </Container>
    <div className='products' style={{marginBottom:"32px"}}>
      <h1 style={{marginTop:"4px", color:"#43ACE7"}}>Teenused</h1>
        <Container style={{overflowX:"auto"}}>
            <div className='products-row' style={{display:"flex",width:"100%", gap:"2rem", padding:"1rem", justifyContent:"space-evenly"}}>
              <a href='/teenused/ortodontia-laste' className='product-item'>
                <div className='Product11'></div>
                <h4>Laste Ortodontia</h4>
              </a>
              <a href='/teenused/esteetiline' className='product-item'>
                <div className='Product12'></div>
                <h4>Esteetiline</h4>
              </a>
              <a href='/teenused/puhastus' className='product-item'>
                <div className='Product13'></div>
                <h4>Puhastus</h4>
              </a>
              <a href='/teenused/reteinerid' className='product-item'>
                <div className='Product14'></div>
                <h4>Reteinerid</h4>
              </a>
            </div>
        </Container>

    </div>

{/* 
      <div className='Products' style={{padding:"0px 0px 96px 0px"}} >
        <h1 style={{margin:"96px 0px 64px 0px"}}>Meie Teenused</h1>
        <div className='Productline' style={{margin:"96px 0px 32px 0px"}}>
          <li style={{listStyleType:"none"}}>
            <div className='Product1'></div>
            <h4 style={{margin:"12px 0px 0px 0px", color:"rgb(83 127 166)"}}>Teeth Whitening</h4>
            <p>Lorem ipsum dolor sit amet, <br></br> consectetur adipiscing elit.</p>
          </li>


          <li style={{listStyleType:"none"}}>
            <div className='Product1'></div>
            <h4 style={{margin:"12px 0px 0px 0px", color:"rgb(83 127 166)"}}>Teeth Whitening</h4>
            <p>Lorem ipsum dolor sit amet, <br></br> consectetur adipiscing elit.</p>
          </li>
          <li style={{listStyleType:"none"}}>
            <div className='Product1'></div>
            <h4 style={{margin:"12px 0px 0px 0px", color:"rgb(83 127 166)"}}>Teeth Whitening</h4>
            <p>Lorem ipsum dolor sit amet, <br></br> consectetur adipiscing elit.</p>
          </li>
                    <li style={{listStyleType:"none"}}>
            <div className='Product1'></div>
            <h4 style={{margin:"12px 0px 0px 0px", color:"rgb(83 127 166)"}}>Teeth Whitening</h4>
            <p>Lorem ipsum dolor sit amet, <br></br> consectetur adipiscing elit.</p>
          </li>
        </div>
      </div>

*/}
  <div style={{minHeight:"65vh", paddingBottom:"16px"}}>
    <Container>
      <h1 style={{textAlign:"start"}} id='valida'></h1>
    </Container>
    
    <Container style={{minHeight:"50vh"}}>
      <div style={{display:"flex", minHeight:"60vh", flexWrap:"wrap", gap:"1rem"}}>
          <div className='aboutphoto' style={{borderRadius:"24px"}} />
          <div style={{borderRadius:"24px", flexDirection:"column", padding:"16px"}} className='aboutT'>
            <div style={{maxWidth:"100%"}}>
              <h1 style={{textAlign:"start"}}>Miks valida meid?</h1>
              <p style={{textAlign:"start", fontSize:"1.25rem"}}>
Pakume ortodontilist ravi lähtudes iga patsiendi
individuaalsetest vajadustest. Meie väike ja hooliv kliinik väärtustab personaalset
lähenemist, rahulikku õhkkonda ning selget suhtlust kogu raviprotsessi jooksul.<br></br>
Kliinikut juhib dr. Riina Einblau, hambaarst-ortodont, kellel on ortodontia
magistrikraad Helsingi Ülikoolist (DDS, MSc in Orthodontics, Helsinki 2001).<br></br>
Meie juures on võimalik:
laste ennetav ortodontiline ravi
, breketravi
ja kaped ehk aligner-ravi<br></br>
Usume, et hea ravitulemus sünnib kogemuse, täpsuse ja hooliva koostöö kaudu.</p>
            </div>

          </div>
      </div>

    
    </Container>
  </div>
  {
    /*
        <div className='About' style={{backgroundColor:"rgba(28, 77, 160,0.125)", padding:"0 64px 0 64px"}}>

          <div style={{display:"flex", height:"100%", gap:"auto"}}>
            <li style={{width:"50%", textAlign:"start", padding:"96px 64px 0 0", listStyleType:"none"}}>
              <h1 style={{color:"rgb(83 127 166)", fontSize:"4rem"}}>Miks Valida meid?</h1>
              <p style={{fontSize:"1.5rem", margin:"64px 0 0 0"}}>it is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here,</p>

            </li>
            <div className='AboutPhoto'></div>
          </div>

        </div>
  */
}

{/*
          <div className='Footer'>
        <div className='FooterItem' style={{width:"25%"}}>
          <h2>Blaudent OÜ</h2>
          <h3>Roopa 12A, 10136 Tallinn</h3>
          <h3>Reg. nr 12500162</h3>
        </div>
        <div style={{width:"25%"}}>
          
        </div>
        <div className='FooterItem' style={{width:"25%"}}>
          <h2>Kontakt</h2>
          <h3>Email: info@blaudent.ee</h3>
          <h3>Tel: +372 5566 1618</h3>
        </div>
      </div>
 */}
           <Container fluid>
            <iframe width="100%" style={{borderRadius:"16px", padding:"0", minHeight:"350px"}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2029.1338349517648!2d24.72545251306723!3d59.43084240278487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46929484d01142dd%3A0xc4cc6ad1c13957b4!2sBlaudent%20O%C3%9C!5e0!3m2!1sen!2sus!4v1756212346673!5m2!1sen!2sus"></iframe>
          </Container>

        </div>
    );
}